import { makeStyles } from '@mui/styles';
import type { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

import BlueGradient from './backgrounds/background-gradient.svg';
import TassatTiled from './backgrounds/TassatLogo-GreyBackground-Tile.svg';

export const screenStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: { minHeight: '100vh' },
    headerContainer: {
        minHeight: '93px',
        borderBottom: `${theme?.app?.applicationColors.enumColors.greyLightest || '#F0F0F0'} solid 1px`
    },
    bodyContainer: { flexGrow: 1 },
    subtitleContainer: {
        backgroundImage: `url("${BlueGradient}")`,
        backgroundSize: 'cover' as const
    },
    subtitleText: {
        width: '376px',
        color: theme?.app?.applicationColors.enumColors.greyLightest || '#F0F0F0',
        fontSize: '45px',
        textAlign: 'right',
        marginRight: '60px'
    },
    footerContainer: {
        height: '93px',
        borderTop: `${theme?.app?.clientTheme.colors.primaryColor || '#3C4F70'} solid 1px`,
        backgroundImage: `url("${TassatTiled}")`,
        backgroundSize: '2048px',
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLightest || '#F0F0F0'
    },
    footerLink: { '&:hover': { textDecoration: 'none' as const }},
    footerLogoContainer: { paddingRight: '19px' },
    footerPOweredByText: {
        color: theme?.app?.applicationColors.fontColor || '#202020',
        fontSize: '12px',
        margin: 0
    },
    footerTassatLogo: {
        height: '22px',
        paddingLeft: '8px'
    }
}));

export const headerStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    logoContainer: {
        height: '55px',
        paddingLeft: '60px'
    },
    logout: {
        marginLeft: 'auto' as const,
        marginRight: '4.25rem'
    }
}));

export const bodyStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    bodyContainer: { padding: '46px 0 46px 60px' },
    pageTitle: {
        color: '#757575',
        fontSize: '50px',
        lineHeight: '58px'
    },
    messageContainer: {
        width: '460px',
        marginTop: '28px',
        marginLeft: '18px'
    },
    messageText: {
        color: '#757575',
        fontSize: '18px',
        lineHeight: '21px',
        paddingBottom: '42px'
    },
    supportButton: {
        height: '35px',
        marginBottom: '46px',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#3C4F70',
        borderRadius: '30px',
        color: theme?.app?.applicationColors.enumColors.white || '#FFFFFF',
        fontSize: '14px',
        lineHeight: '17px',
        textTransform: 'none' as const,
        '&:last-child': { marginBottom: 0 }
    }
}));